import _objectSpread from '@babel/runtime/helpers/objectSpread2';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import styled from 'styled-components';
import { useTabContext, getTabId, getPanelId } from '../TabsContext/TabsContext.js';
import { jsx } from 'react/jsx-runtime';

var _excluded = ["children", "value"];
var TabPanel = styled.div.withConfig({
  displayName: "TabsPanel__TabPanel",
  componentId: "sc-158zd9w-0"
})(["&&{outline-color:", ";}"], function (_ref) {
  var theme = _ref.theme;
  return theme.CTAColors.primaryVariant;
});
var TabsPanel = /*#__PURE__*/React.forwardRef(function TabsPanel2(props, ref) {
  var children = props.children,
    value = props.value,
    rest = _objectWithoutProperties(props, _excluded);
  var context = useTabContext();
  if (context === null) {
    throw new TypeError("No TabContext provided");
  }
  var isSelected = value === context.value;
  return /*#__PURE__*/jsx(TabPanel, _objectSpread(_objectSpread({}, rest), {}, {
    "aria-labelledby": getTabId(context, value),
    hidden: !isSelected,
    id: getPanelId(context, value),
    ref: ref,
    role: "tabpanel",
    tabIndex: 0,
    children: isSelected && children
  }));
});
TabsPanel.displayName = "TabsPanel";

export { TabsPanel };
